import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  value:any = null;
  constructor(private router:Router) { 
    const navigation = this.router.getCurrentNavigation();
    this.value = navigation?.extras.state;
  }

  ngOnInit(): void {
  }

}
